module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.gotoRegister.show) ? _c('div', {
    staticClass: "gotoRegister"
  }, [_c('div', {
    staticClass: "gotoRegister-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "gotoRegister-box"
  }, [(_vm.gotoRegister.allowClose) ? _c('div', {
    staticClass: "gotoRegister-box-close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/prompt_close.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gotoRegister-box-title"
  }, [_vm._v("市长信箱")]), _vm._v(" "), _c('div', {
    staticClass: "gotoRegister-box-content"
  }, [_c('div', [_vm._v("提示")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gotoRegister.content || "您的账号因未实名认证已无法使用，您可重新注册使用。"))]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v("去注册")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7331fe52"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gotoRegister.vue
// module id = 197
// module chunks = 12